class BLCollection extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.stockStates = new Map();
    this.lowStock = JSON.parse(this.querySelector('[data-stock-levels]').textContent);
    this.optionNames = JSON.parse(this.querySelector('[data-option-names]').textContent);
    this.sizeIndex = this.optionNames.findIndex((name) => /^size$/i.test(name));
    this.lengthIndex = this.optionNames.findIndex((name) => /^length$/i.test(name));
    this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
    this.form = this.querySelector('[data-filters]');
    this.cards = [...this.querySelectorAll('[data-color]')];
    this.grid = this.querySelector('[data-grid]');
    this.dialog = this.querySelector('dialog');
    this.colorIndex = Number(this.dataset.colorIndex);
    this.form.addEventListener('change', () => this.update());
    this.form.addEventListener('submit', (event) => event.preventDefault());
    this.form.addEventListener('reset', () => requestAnimationFrame(() => this.update()));
    this.querySelector('[data-sort]').addEventListener('change', () => this.update());
    this.querySelector('[data-clear]').addEventListener('click', () => this.form.reset());
    this.querySelectorAll('[data-rail-color]').forEach((link) => {
      link.addEventListener('click', (event) => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        const inputs = [...this.form.elements].filter((input) => input.name === `option-${this.colorIndex}`);
        const selected = inputs.find((input) => input.value === link.dataset.railColor);
        const wasChecked = selected?.checked;
        inputs.forEach((input) => { input.checked = input === selected && !wasChecked; });
        this.update();
      });
    });
    this.querySelector('[data-open-filters]').addEventListener('click', () => {
      this.querySelector('[data-dialog-mount]').append(this.form);
      this.dialog.showModal();
    });
    this.querySelectorAll('[data-close-filters]').forEach((button) => button.addEventListener('click', () => this.dialog.close()));
    this.dialog.addEventListener('close', () => this.querySelector('.blc__filter-mount').append(this.form));
    this.dialog.addEventListener('click', (event) => { if (event.target === this.dialog && event.clientX < this.dialog.getBoundingClientRect().left) this.dialog.close(); });
    this.viewport = matchMedia('(min-width: 750px)');
    this.onViewport = () => { if (this.viewport.matches && this.dialog.open) this.dialog.close(); };
    this.viewport.addEventListener('change', this.onViewport);
    this.setupQuickAdd();
    this.classList.add('is-ready');
    this.update();
  }
  disconnectedCallback() {
    this.viewport?.removeEventListener('change', this.onViewport);
    this.stockStates?.forEach((state) => { clearTimeout(state.timer); state.observer?.disconnect(); });
  }
  setupQuickAdd() {
    this.quickDialog = this.querySelector('[data-quick-dialog]');
    this.quickForm = this.querySelector('[data-quick-form]');
    this.quickSelects = [...this.querySelectorAll('[data-quick-option]')];
    this.querySelectorAll('[data-quick-add]').forEach((button) => button.addEventListener('click', () => this.openQuick(button.closest('[data-color]'))));
    this.querySelector('[data-close-quick]').addEventListener('click', () => this.quickDialog.close());
    this.quickDialog.addEventListener('close', () => this.updateStock(this.querySelector('[data-quick-stock]'), null));
    this.quickDialog.addEventListener('click', (event) => {
      if (event.target !== this.quickDialog) return;
      const rect = this.quickDialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.quickDialog.close();
    });
    this.quickSelects.forEach((select) => {
      [...select.options].forEach((option) => { option.dataset.label = option.textContent; });
      select.addEventListener('change', () => {
        if (this.pending) return;
        const index = Number(select.dataset.quickOption);
        this.quickSelected[index] = select.value || null;
        if (index !== this.sizeIndex && this.sizeIndex >= 0) {
          this.quickSelected[this.sizeIndex] = null;
          this.quickSelects.find((control) => Number(control.dataset.quickOption) === this.sizeIndex).value = '';
        }
        this.querySelector('[data-quick-status]').textContent = '';
        this.updateQuick();
      });
    });
    this.quickForm.addEventListener('submit', (event) => { event.preventDefault(); this.purchase(); });
  }
  openQuick(card) {
    if (this.pending) return;
    this.quickSelected = this.optionNames.map(() => null);
    this.quickSelected[this.colorIndex] = card.dataset.color;
    this.quickSelects.forEach((select) => {
      const index = Number(select.dataset.quickOption);
      const selected = [...this.form.querySelectorAll('input:checked')].filter((input) => input.name === `option-${index}`);
      select.value = selected.length === 1 ? selected[0].value : '';
      this.quickSelected[index] = select.value || null;
    });
    this.querySelector('[data-quick-color]').textContent = card.dataset.color;
    this.querySelector('[data-quick-status]').textContent = '';
    this.quickDialog.showModal();
    this.updateQuick();
    this.quickSelects.find((select) => !select.value)?.focus();
  }
  matching(options) {
    return this.variants.filter((variant) => options.every((value, index) => value == null || value === variant.options[index]));
  }
  updateQuick() {
    const complete = this.quickSelected.every((value) => value != null);
    const matches = this.matching(this.quickSelected);
    this.quickVariant = complete ? matches[0] : null;
    this.quickSelects.forEach((select) => {
      const index = Number(select.dataset.quickOption);
      select.disabled = Boolean(this.pending);
      [...select.options].forEach((option) => {
        if (!option.value) return;
        const candidate = [...this.quickSelected];
        candidate[index] = option.value;
        if (index !== this.sizeIndex && this.sizeIndex >= 0) candidate[this.sizeIndex] = null;
        const available = this.matching(candidate).some((variant) => variant.available);
        option.disabled = !available;
        option.textContent = `${option.dataset.label}${available ? '' : ' — Sold out'}`;
      });
    });
    const ordered = [...matches].sort((a, b) => a.price - b.price);
    const priced = this.quickVariant || ordered[0];
    const price = this.querySelector('[data-quick-price]');
    const compare = this.querySelector('[data-quick-compare]');
    price.textContent = priced ? `${!complete && ordered.at(-1).price !== priced.price ? 'From ' : ''}${priced.money}` : '';
    compare.hidden = !priced?.compare || priced.compare <= priced.price;
    compare.textContent = priced?.compareMoney || '';
    compare.closest('.blc__price').classList.toggle('is-sale', !compare.hidden);
    const submit = this.querySelector('[data-quick-submit]');
    submit.disabled = Boolean(this.pending || !this.quickVariant?.available);
    submit.textContent = this.pending ? 'Adding…' : !complete ? 'Choose your fit' : !this.quickVariant ? 'Unavailable' : !this.quickVariant.available ? 'Sold out' : 'Add to cart';
    this.querySelector('[data-quick-details]').href = `${this.dataset.productUrl}?${this.quickVariant ? `variant=${this.quickVariant.id}` : `color=${encodeURIComponent(this.quickSelected[this.colorIndex])}`}`;
    this.updateStock(this.querySelector('[data-quick-stock]'), this.quickVariant);
  }
  updateStock(row, variant) {
    if (!row) return;
    const options = variant?.options || [];
    const key = [options[this.colorIndex], options[this.lengthIndex], options[this.sizeIndex]].join('|');
    const quantity = Number.isInteger(this.lowStock[key]) ? Math.max(5, this.lowStock[key] + 3) : this.lowStock[key];
    const eligible = variant?.available && Number.isInteger(quantity) && quantity > 0 && quantity <= (Number(this.dataset.lowStockThreshold) || 10);
    const identity = `${key}|${quantity}|${Boolean(eligible)}`;
    const previous = this.stockStates.get(row);
    if (previous?.identity === identity) return;
    clearTimeout(previous?.timer);
    previous?.observer?.disconnect();
    const state = { identity };
    this.stockStates.set(row, state);
    row.hidden = !eligible;
    row.classList.remove('is-searching');
    row.textContent = '';
    if (!eligible) return;
    row.textContent = 'Low in stock';
    state.observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.5)) return;
      state.observer.disconnect();
      row.classList.add('is-searching');
      row.textContent = 'Searching stock';
      state.timer = setTimeout(() => {
        if (!this.isConnected || this.stockStates.get(row) !== state) return;
        row.classList.remove('is-searching');
        row.textContent = `Low in stock: Only ${quantity} ${quantity === 1 ? 'pair' : 'pairs'} left in size ${options[this.sizeIndex]}`;
      }, 1500);
    }, { threshold: 0.5 });
    state.observer.observe(row);
  }
  async purchase() {
    if (this.pending || !this.quickVariant?.available) return;
    const variant = this.quickVariant;
    this.pending = true;
    this.updateQuick();
    this.update();
    this.querySelector('[data-quick-status]').textContent = '';
    try {
      const response = await fetch(this.dataset.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] }) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Could not add this fit. Please try again.');
    } catch (error) {
      this.lowStock = {};
      this.pending = false;
      this.updateQuick();
      this.update();
      this.querySelector('[data-quick-status]').textContent = error.message || 'Could not add this fit. Please try again.';
      return;
    }
    const drawer = document.querySelector('bl-pdp-cart');
    if (drawer?.open) await drawer.prefetch?.();
    this.pending = false;
    this.updateQuick();
    this.update();
    this.quickDialog.close();
    try {
      if (drawer?.open) await drawer.open();
      else window.location.assign(window.blOfferURL?.(this.dataset.cartUrl) || this.dataset.cartUrl);
    } catch { window.location.assign(window.blOfferURL?.(this.dataset.cartUrl) || this.dataset.cartUrl); }
  }
  update() {
    const checked = [...this.form.querySelectorAll('input:checked')];
    const groups = new Map();
    checked.forEach((input) => {
      if (!groups.has(input.name)) groups.set(input.name, []);
      groups.get(input.name).push(input.value);
    });
    const matches = this.variants.filter((variant) => [...groups].every(([name, values]) => name === 'available' ? variant.available : values.includes(variant.options[Number(name.replace('option-', ''))])));
    const sort = this.querySelector('[data-sort]').value;
    let count = 0;
    this.cards.forEach((card) => {
      const variants = matches.filter((variant) => variant.options[this.colorIndex] === card.dataset.color);
      card.hidden = variants.length === 0;
      if (card.hidden) { this.updateStock(card.querySelector('[data-card-stock]'), null); return; }
      count += 1;
      const ordered = [...variants].sort((a, b) => a.price - b.price);
      const lowest = ordered[0];
      const available = ordered.find((variant) => variant.available);
      const selected = available || lowest;
      const varies = lowest.price !== ordered.at(-1).price;
      card.dataset.price = lowest.price;
      card.querySelector('[data-price-label]').textContent = `${varies ? 'From ' : ''}${lowest.money}`;
      const compare = card.querySelector('[data-compare]');
      compare.hidden = !lowest.compare || lowest.compare <= lowest.price;
      compare.closest('.blc__price').classList.toggle('is-sale', !compare.hidden);
      compare.textContent = lowest.compareMoney;
      card.querySelector('[data-sold]').hidden = Boolean(available);
      const completeFit = selected.options.every((value, index) => index === this.colorIndex || (groups.get(`option-${index}`)?.length === 1 && groups.get(`option-${index}`)[0] === value));
      this.updateStock(card.querySelector('[data-card-stock]'), completeFit ? selected : null);
      const quick = card.querySelector('[data-quick-add]');
      quick.disabled = !available || Boolean(this.pending);
      quick.textContent = available ? 'Add To Cart' : 'Sold out';
      const target = completeFit ? `variant=${selected.id}` : `color=${encodeURIComponent(card.dataset.color)}`;
      card.querySelectorAll('[data-card-link]').forEach((link) => { link.href = `${this.dataset.productUrl}?${target}`; });
    });
    const orderedCards = [...this.cards];
    if (sort === 'price-asc') orderedCards.sort((a, b) => Number(a.dataset.price) - Number(b.dataset.price));
    if (sort === 'price-desc') orderedCards.sort((a, b) => Number(b.dataset.price) - Number(a.dataset.price));
    if (sort === 'name') orderedCards.sort((a, b) => a.dataset.color.localeCompare(b.dataset.color));
    orderedCards.forEach((card) => this.grid.append(card));
    this.querySelector('[data-count]').textContent = `${count} ${count === 1 ? 'colorway' : 'colorways'}`;
    this.querySelector('[data-dialog-count]').textContent = count;
    this.querySelector('[data-empty]').hidden = count > 0;
    this.querySelector('[data-filter-count]').textContent = checked.length ? `(${checked.length})` : '';
    this.querySelectorAll('[data-rail-color]').forEach((link) => link.setAttribute('aria-current', String(groups.get(`option-${this.colorIndex}`)?.includes(link.dataset.railColor) || false)));
    const active = this.querySelector('[data-active]');
    active.replaceChildren();
    active.hidden = checked.length === 0;
    checked.forEach((input) => {
      const button = document.createElement('button');
      button.type = 'button';
      const label = input.name === 'available' ? 'In stock' : input.value;
      button.textContent = `${label} ×`;
      button.setAttribute('aria-label', `Remove ${label} filter`);
      button.addEventListener('click', () => { input.checked = false; this.update(); this.querySelector('[data-count]').setAttribute('tabindex', '-1'); this.querySelector('[data-count]').focus(); });
      active.append(button);
    });
  }
}
if (!customElements.get('bl-collection')) customElements.define('bl-collection', BLCollection);
